export class UserFave {
    faves: Array<FaveOrder>;

    public static Make(obj: any): UserFave {
        const userFaves = new UserFave();
        Object.assign(userFaves, obj);
        return userFaves;
    }
}

export class UserFaveProduct {
    imagePath: string;
    savedproducts: Array<FaveCustomProduct>;

    public static Make(obj: any): UserFaveProduct {
        const userFaveProduct = new UserFaveProduct();
        Object.assign(userFaveProduct, obj);
        return userFaveProduct;
    }
}

export class FaveCustomProduct {
    dateCreated: number;
    id: number;
    name: string;
    product: FaveProduct;
}

export class FaveOrder {
    id: number;
    name: string;
    vendorid: number;
    vendorname: string;
    disabled: boolean;
    online: boolean;
    isdefault: boolean;
    products: Array<FaveProduct>;
}

export class FaveProduct {
    productid: number;
    chainproductid?: number;
    name: string;
    quantity: number;
    choices: Array<FaveChoice>;
    disabled: boolean;
    recipient: string;
    specialinstructions: string;
    source?: string;
}

export class FaveChoice {
    optionid: number;
    name: string;
    quantity: number;
}
